/**
 * @generated SignedSource<<ae657ada28cf223e0195393d9f14168f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useUserActivities_query$data = {
  readonly currentUser: {
    readonly userActivities: {
      readonly nodes: ReadonlyArray<{
        readonly activityId: any;
      } | null | undefined>;
    };
  } | null | undefined;
  readonly " $fragmentType": "useUserActivities_query";
};
export type useUserActivities_query$key = {
  readonly " $data"?: useUserActivities_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"useUserActivities_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useUserActivities_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "orderBy",
              "value": [
                "ACTIVITY_BY_ACTIVITY_ID__SEQUENCE_ASC"
              ]
            }
          ],
          "concreteType": "UserActivityConnection",
          "kind": "LinkedField",
          "name": "userActivities",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserActivity",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "activityId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "userActivities(orderBy:[\"ACTIVITY_BY_ACTIVITY_ID__SEQUENCE_ASC\"])"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "73552b2c289a3bfb757fb89ca89ec519";

export default node;
